import { useMemo } from "react";

import { Icon } from "@repo/core/components/core/Icon";
import { ListTile } from "@repo/core/components/layout/ListTile";
import { TileLabel } from "@repo/core/components/layout/ListTile/types";

import { LocationListTileProps } from "./types";

export const LocationListTile = ({
  id,
  name,
  region,
  address,
  isActive = false,
  onPress
}: LocationListTileProps) => {
  const labels = useMemo(() => {
    return [
      new TileLabel({
        text: name || "",
        fontColor: "$textLight900",
        fontWeight: 600
      }),
      new TileLabel({
        text: region || "",
        fontWeight: 500
      }),
      new TileLabel({
        text: address || "",
        fontSize: "xs"
      })
    ];
  }, [address, name, region]);

  return (
    <ListTile
      id={id}
      onPress={onPress}
      labels={labels}
      isActive={isActive}
      leading={<Icon name="location-dot" size="sm" color="$primary700" />}
    />
  );
};
